import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import { VoiceAppResponseItem, VoiceAppTableData, VoiceAppTableRowActions } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: VoiceAppResponseItem[],
  actionsHandling: VoiceAppTableRowActions
): VoiceAppTableData[] =>
  data.map((voiceAppItem: VoiceAppResponseItem) => {
    const { appId, createDate, settings } = voiceAppItem;
    const actions = [
      {
        name: TABLE_ACTION.EDIT,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actionsHandling.edit({
            appId,
            appUrl: settings.appUrl,
            debugEnabled: settings.debugEnabled,
            authorizationMethod: settings.authorizationMethod,
            status: settings.status,
            process: settings.process
          });
        }
      }
    ];

    return {
      ...voiceAppItem,
      id: appId,
      createDate,
      appUrl: settings.appUrl,
      status: settings.status,
      debugEnabled: settings.debugEnabled,
      actions: <ActionsColumn actions={actions} />
    };
  });
